import {
  OPEN_DROPDOWN,
  OPEN_COMPLETE,
  CLOSE_DROPDOWN,
  DROPDOWN_NAMES
} from "./constants";
export { openDropdown, closeDropdown, openComplete } from "./actions";
export { getDropdownIsOpen, getDropdownIsHidden } from "./selectors";
export {
  OPEN_DROPDOWN,
  OPEN_COMPLETE,
  CLOSE_DROPDOWN,
  DROPDOWN_NAMES,
  MY_ACCOUNT,
  MINIBAG
} from "./constants";

export const initDropdownStates = dropdownNames =>
  dropdownNames.reduce((dropdowns, name) => {
    dropdowns[name] = {
      isOpen: false
    };
    return dropdowns;
  }, {});

const initialState = initDropdownStates(DROPDOWN_NAMES);

export default (state = initialState, action) => {
  switch (action.type) {
    case OPEN_COMPLETE: {
      let dropdownToggles = DROPDOWN_NAMES.filter(
        name => name !== action.name
      ).reduce((dropdowns, name) => {
        dropdowns[name] = { isOpen: false };
        return dropdowns;
      }, {});

      return {
        ...state,
        ...dropdownToggles
      };
    }
    case OPEN_DROPDOWN: {
      let dropdownToggles = DROPDOWN_NAMES.reduce((dropdowns, name) => {
        dropdowns[name] =
          name === action.name
            ? { isOpen: true }
            : { isOpen: false, isHidden: true };
        return dropdowns;
      }, {});

      return {
        ...state,
        ...dropdownToggles
      };
    }
    case CLOSE_DROPDOWN:
      return {
        ...state,
        [action.name]: { isOpen: false }
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./template/state/modules/dropdown/index.js